import { Route, Routes } from 'react-router-dom'
import NotFound from '../../components/NotFound'
import VideoList from './VideoList'
import VideoCreate from './VideoCreate'
import VideoEdit from './VideoEdit'
export default function Video() {
  return (
    <Routes>
      <Route index element={<VideoList />} />
      <Route path="/new" element={<VideoCreate />} />
      <Route path=":id" element={<VideoEdit />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
